var subModule = {
    init: function () {
        this.initPromocodeForm();
        this.initVarious();
    },
    initVarious: function () {
        $(document).on('change', '.hasDependent', function (e) {
            e.preventDefault();
            var $dependent = $($(this).attr('data-dependent'));
            var isChecked = this.checked;
            if ($dependent.length > 0) {
                $dependent.toggle(isChecked);
                $('.modal-page--open').trigger('modal:hchange');
            }
        });

        $(document).on('click', '.js-close-modal-trigger', function (e) {
            e.preventDefault();

            $('.modal-page__close-btn').click();
        });

        $(document).on('click', '.oferta-agreement input.uk-checkbox', function (e) {
            if(typeof($('#deactivate-sub')[0]) !== undefined) {
                $('.oferta-agreement input.uk-checkbox').each(function () {
                    if ($(this)[0].checked) {
                        $('#deactivate-sub').removeAttr('disabled');
                    }
                });
                if ($('.oferta-agreement input.uk-checkbox:checked').length === 0) {
                    $('#deactivate-sub').attr('disabled', 'true');
                }
            }
        });

        $(document).on('click', '.js-form-next-step', function (e) {
            e.preventDefault();
            let isDependent = $('.isDependent');

            if (isDependent.length > 0) {
                let dependentId = isDependent.attr('id')
                let dependentElement = $('[data-dependent="#' + dependentId + '"]');

                if (dependentElement.is(':checked')) {
                    if ($('.isDependent textarea').val().trim() === '') {
                        $('.isDependent span').removeClass('hidden-important');

                        return;
                    }
                }
            }

            let $form = $(this).closest('form');

            $form.find('.sub-cancel-form__step').removeClass('sub-cancel-form__step--current');
            $form.find('.sub-cancel-form__step--final').addClass('sub-cancel-form__step--current');
        });

        $(document).on('submit', '.sub-cancel-form', function (e) {
            e.preventDefault();

            var $form = $(this);
            var endpoint = $form.attr('action');
            var method = $form.attr('method');
            var ajaxData = $form.serialize();

            $.ajax({
                url: endpoint,
                method: method,
                dataType: 'json',
                data: ajaxData,
                success: function (response) {
                    if (response.redirectUrl) {
                        location.href = response.redirectUrl;
                    } else if (response.reload) {
                        location.reload();
                    } else if (response.status === 'failed') {
                        $('#js-ajax-link-error').removeAttr('hidden');
                        $('#js-ajax-link-error').children('span').html(response.errors[0]);
                        $('.modal-page--open').find('.modal-page__close-btn').click();
                    } else {
                        $('.modal-page--open').find('.modal-page__close-btn').click();
                    }
                }
            });
        })
    },
    initPromocodeForm: function () {
        $(document).on('submit', '.sub-promocode__form', function (e) {
            e.preventDefault();
            var $form = $(this);
            var endpoint = $form.attr('endpoint');
            var method = $form.attr('method');
            var ajaxData = $form.serialize();
            var subscriptionsBlock = $form.attr('subscriptionsBlock');

            let lectureId = window.transactionFormOptions?.item?.id;
            let promoCod = $('input[name="promoCode"]', this).val();

            $.ajax({
                url: endpoint,
                method: method,
                dataType: 'json',
                data: {
                    promoCode: promoCod,
                    lectureId: lectureId,
                },
                success: function (response) {
                    if (Object.keys(response.promoCode).length > 0) {
                        var promoCodeObj = response.promoCode;

                        if (response.singleVideo === true && response.price === 0 && response.lectureId !== null) {
                            window.location.href = `/subscription-purchase/purchase-single-event?lectureId=${response.lectureId}`;
                        }

                        switch (promoCodeObj.isValid) {
                            case true:
                                $form.find('.promocode-response-message').removeClass('.promocode-response-message--error').html('');

                                $form.find('.use-promo').hide();
                                $form.find('.delete-promo').show();
                                $form.find('.custom-input-flex').addClass('active');
                                $('html, body').animate({
                                    scrollTop: $('.subscription-options').offset().top - 100
                                });

                                break;
                            case false:
                                var errorMessage = promoCodeObj.message;
                                $form.find('.promocode-response-message').addClass('promocode-response-message--error').html($('<div class="payment-option-warning">\n' +
                                    '                                            <span class="error">' + errorMessage + '</span>\n' +
                                    '                                        </div>'));
                                break;
                        }
                    }

                    subModule.recalculatePriceMatrix(response, subscriptionsBlock);
                }
            });
            //buyModule.recalculatePriceMatrix($form, bFormPriceMatrix, promoCodeValue);

            $(document).on('click', '.delete-promo', function(e) {
                e.preventDefault();
                let $form = $(this).closest('form');

                $form.find('.use-promo').show();
                $form.find('.delete-promo').hide();
                $form.find('.custom-input-flex').removeClass('active');
                $form.find('.promoCode-input').val('');
                $form.find('.promocode-response-message').html('');

                $form.submit();

                $('.subscription-card').each(function(index) {
                    $('.subscription-card').eq(index).show();
                    $('.card-header-main').show();
                    $('.card-header-promo-code').hide();
                    $('.grid-card-text-original-price').hide();
                    $('.stripe-system').show();
                    $('.grid-card__price-link-text__new-price').removeClass('text-warning');
                });

                $(this).off(e);
            });
        });
    },
    recalculatePriceMatrix: function (recalcResponse, subscriptionsGrid) {
        var subPriceMatrix = recalcResponse.priceMatrix;
        var subOptions = subPriceMatrix.options;

        subOptions.forEach((subOption) => {
            var subid = subOption.id;
            var $subGridItem = $('[data-subid="' + subid + '"');
            if (subOption.finalPrice === 0) {
                var goUrl = $subGridItem.find('.js-sub-buy-btn').attr('data-url');
                location.href = goUrl;
            }

            if (subOption.offerAvailable === false) {
                $subGridItem.hide();
            }

            if (subOption.finalPrice || subOption.finalPrice === 0) {
                $subGridItem.find('.grid-card__price-link-text__new-price').text(app.formatPriceRoubles(subOption.finalPrice, 'RUB'));

                if (subOption.originalPrice && subOption.originalPrice > subOption.finalPrice) {
                    $subGridItem.find('.grid-card__price-link-text__new-price').addClass('text-warning');
                } else {
                    $subGridItem.find('.grid-card__price-link-text__new-price').removeClass('text-warning');
                }

                $subGridItem.find('.grid-card__price-link-text__old-price').text(app.formatPriceRoubles(subOption.originalPrice, 'RUB'));
            }

            if (subOption.originalPrice) {
                if (subOption.originalPrice > subOption.finalPrice) {
                    if (subOption.offerDuration !== null) {
                        $subGridItem.find('.card-header-main').hide();
                        $subGridItem.find('.card-header-promo-code').text(subOption.offerDuration);
                        $subGridItem.find('.card-header-promo-code').show();
                    }

                    $subGridItem.find('.grid-card-text-original-price').show();
                    $subGridItem.find('.grid-card-text-original-price').text(app.formatPriceRoubles(subOption.originalPrice, 'RUB'));

                    // hide payment STRIPE with promocede
                    // let platronSelect = $subGridItem.find('.platron-system');
                    // let stipeSystem = $subGridItem.find('.stripe-system');
                    //
                    // stipeSystem.hide();
                    //
                    // if(!platronSelect.hasClass('active')){
                    //     platronSelect.addClass('active')
                    // }
                    //
                    // platronSelect.find('input[type=checkbox]').prop('checked', true);
                    // stipeSystem.find('input[type=checkbox]').prop('checked', false);


                } else {
                    $subGridItem.find('.grid-card__price-link-text__old-price').text('');
                }
            } else {
                $subGridItem.find('.grid-card__price-link-text__old-price').text('');
            }
        });
    }
}

$("document").ready(function () {
    subModule.init();
});
